import { Role } from "@/router/_helper";

const summary = {
  path: "/student-summary",
  name: "studentSummary",
  component: () => import(/* webpackChunkName: "studentSummary" */ "@/components/student/StudentSummary.vue"),
  meta: { authorize: [Role.Admin, Role.ComplianceStudent], requiresAuth: true }
};

export default summary;
